
import { assertNever } from '@tableau/data-structures';
import { VizPortalWebClientRequester } from '@tableau/vizportal-webclient-api';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { ViewDetailsByPathFragment } from '../../../../../gen-src/queries';
import { TableauUser } from '../../../data-catalog-shared';
import { HeaderDetails } from './HeaderDetails';
import { SheetField } from './SheetField';
import { SheetFieldsList } from './SheetFieldsList';
import { SparklineQueryWrapper } from './SparklineQueryWrapper';
import { SparklineWithCaption } from './SparklineWithCaption';
import { lineagePanelBody, SparklineHeader } from './ViewerPaneStyles';
import { VizClientDatasourceList } from './VizClientDatasourceList';
import { VizClientDatasource } from './VizClientInterfaces';

export interface VizClientLineagePanelBodyProps {
  readonly viewId: string;
  readonly viewName: string | null;
  readonly viewType: ViewDetailsByPathFragment['__typename'];
  readonly viewPath: string;
  readonly owner: TableauUser | null;
  readonly datasources: ReadonlyArray<VizClientDatasource>;
  readonly datasourceFields: ReadonlyArray<Readonly<SheetField>>;
  readonly worksheetFields: ReadonlyArray<Readonly<SheetField>>;
  readonly modifiedDate?: string;
  readonly workbookName: string | null;
  readonly workbookVizportalUrlId: string;
  readonly vizPortalWebClientRequester: VizPortalWebClientRequester;
  readonly projectName: string | null;
  readonly projectVizportalUrlId: string | null;
}


/** Render the body of the lineage panel. */
export function VizClientLineagePanelBody(props: VizClientLineagePanelBodyProps) {
  return (
    <div className={lineagePanelBody} data-tb-test-id='data-details-panel-body'>
      <HeaderDetails
        {...props}
        sparklineElement={<SparklineElement {...props} />}
      />

      <VizClientDatasourceList
        datasources={props.datasources}
        workbookVizportalUrlId={props.workbookVizportalUrlId}
      />

      <SheetFieldsList
        datasourceFields={props.datasourceFields}
        worksheetFields={props.worksheetFields}
        workbookVizportalUrlId={props.workbookVizportalUrlId}
      />
    </div>
  );
}

function getHeaderMessageForViewType(viewType: VizClientLineagePanelBodyProps['viewType']): string {
  switch (viewType) {
    case 'Dashboard':
      return Messages.ViewingsOfThisDashboard();
    case 'Sheet':
      return Messages.ViewingsOfThisSheet();
    default:
      assertNever(viewType);
      return '';
  }
}

function SparklineElement(props: VizClientLineagePanelBodyProps): JSX.Element {
  return (
    <SparklineQueryWrapper
      vizPortalWebClientRequester={props.vizPortalWebClientRequester}
      viewPath={props.viewPath}
    >
      {({ dataPoints }) => (
        <>
          <SparklineHeader>{getHeaderMessageForViewType(props.viewType)}</SparklineHeader>
          <SparklineWithCaption caption={Messages.SparklineCaption()} dataPoints={dataPoints} />
        </>
      )}
    </SparklineQueryWrapper>
  );
}

